import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { LocalStorageKeys } from '../../core/local-storage';
import './cookie-message.scss';



export const CookieMessage = () => {
  const { t } = useTranslation();
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    const acceptedCookies = window.localStorage.getItem(LocalStorageKeys.ACCEPTED_COOKIES);
    if (acceptedCookies !== 'true') {
      setShow(true);
    }
    return () => {};
  }, []);
  const onClick = () => {
    window.localStorage.setItem(LocalStorageKeys.ACCEPTED_COOKIES, 'true');
    setShow(false);
  };

  return show ? (
    <div className="cookie-message">
      <div className="cookie-message-content">
        <h3>We Use Cookies</h3>
        <p>
          By visiting and interacting with Nexar’s website, I agree to the use of cookies as stipulated in its{' '}
          <a
            href={'https://www.getnexar.com/cookie'}
            style={{ fontWeight: 'bold', textDecoration: 'underline', color: 'white' }}
          >
            Cookie Policy
          </a>
        </p>
        <div className="button" onClick={onClick}>
          {t('cookieMessage.gotIt')}
        </div>
      </div>
    </div>
  ) : null;
};

export default CookieMessage;
